<div class="event-management">
  <div class="event-management__header">
    <div>
      <div class="event-management__title">
        {{ 'events' | t }}

        <app-badge color="secondary">{{ eventCount }}</app-badge>
      </div>

      {{ 'event_management_header_description' | t }}
    </div>

    <div>
      <app-button buttonStyle="action"
                  (click)="createEvent()">

        {{ 'create_new_event' | t }}
      </app-button>
    </div>
  </div>
  <div class="event-management__actions">
    <div></div>
    <app-input class="event-management__search-input"
               [fc]="searchControl"
               [icon]="ICONS.SEARCH"></app-input>
  </div>

  <table class="event-management__table">
    <tr>
      <th>
        {{ 'title' | t }}
      </th>
      <th>
        {{ 'sports' | t }}
      </th>
      <th>
        {{ 'location' | t }}
      </th>
      <th>
        {{ 'date' | t }}
      </th>
      <th>
        {{ 'status' | t }}
      </th>
      <th></th>
    </tr>
    <app-event-management-event-row
      *ngFor="let event of events$ | ngrxPush; trackBy: trackByFn"
      (edit)="editEvent($event)"
      (delete)="openDeleteConfirmPopup($event)"
      [event]="event"
    ></app-event-management-event-row>
  </table>
</div>

<ng-template #deletePopup>
  <app-delete-popup (delete)="deleteEvent($event)"
                    [mainText]="'delete_popup_main_text_event' | t"
                    [helperText]="'delete_popup_helper_text_event' | t">
  </app-delete-popup>
</ng-template>
